import { createClient } from '@supabase/supabase-js';

// Créer un client Supabase pour les requêtes directes depuis le frontend
// Utilisé uniquement pour les statistiques dans l'interface d'administration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);
